module.exports = __webpack_public_path__ + "static/media/BE.c43e2634.svg";